export default "__VITE_ASSET__rytqGTyJ__"